import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { styled } from '@egoist/vue-emotion'
import * as getters from '../../../builder/src/js/store/modules/getters'
import * as actions from '../../../builder/src/js/store/modules/actions'
import { mapGetters, mapState, mapActions } from 'vuex'
import CvtInput from '../molecules/Input'
import { BuilderIntegrationsAuthTemplate } from './builder-integrations-auth'
import * as constants from '../../../builder/src/js/common/constants/constants'
Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

const getIntegrationsContainer = () => styled('div')`
  display: flex;
  gap: 15px;
  width: 100%;
  flex-wrap: wrap;
`

const getIntegrationsItem = () => styled('div')`
  width: 210px;
  height: 230px;
  padding: 15px 25px;
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }
`

const getIntegrationsAddItem = () => styled('div')`
  width: 210px;
  height: 214px;
  padding: 15px 25px;
  box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 7px;
  cursor: pointer;
  border: 1px dashed ${Colors.PRIMARY[500]};
`

const getIntegrateCheck = () => styled('p')`
  display: flex;
  justify-content: space-between;
  margin: 0;
  height: 20px;
  margin-bottom: 8px;
`

const getIntegrationInnerContainer = () => styled('div')`
  text-align: center;
`

const getIntegrationImage = () => styled('div')`
  height: 60px;
  margin-bottom: 15px;
`

const getIntegrationAddImage = () => styled('div')`
  height: 70px;
  width: 70px;
  border: 4px solid ${Colors.PRIMARY[500]};
  border-radius: 50%;
  display: grid;
  place-content: center;
  margin-bottom: 10px;
`

const getIntegrationName = () => styled('div')`
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 12px;
  color: ${Colors.PRIMARY[500]};
`

const getIntegrationDescription = () => styled('div')`
  font-weight: 400;
  font-size: 14px;
  color: ${Colors.BASIC[500]};
`

const getIntegrationAddInnerContainer = () => styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const getInputContainer = () => styled('div')`
  width: 90%;
  margin-bottom: 30px;
`

const getConnectInfoIconWrap = () => styled('p')`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: ${Colors.BASIC[400]};
`

const getConnectInfoIcon = () => styled('p')`
  width: 16px;
  height: 16px;
  border: 1px solid ${Colors.BASIC[400]};
  border-radius: 50%;
  display: grid;
  place-content: center;
  margin: 4px;
`

const getInfoIcon = () => styled('i')`
  color: ${Colors.BASIC[400]};
  font-size: 8px;
`

const getIntegrationsHeading = () => styled('div')`
  color: ${Colors.BASIC[500]};
  margin-bottom: 15px;
`

const getIntegrateCheckIcon = () => styled('i')`
  color: ${Colors.SUCCESS[500]};
  height: 15px;
`

const getIntegrationAddIcon = () => styled('i')`
  color: ${Colors.PRIMARY[500]};
  font-size: 30px;
`

const getIntegrationNewLabel = () => styled('span')`
  font-size: 12px;
  color: ${Colors.BASIC.WHITE};
  background: ${Colors.INFO[500]};
  padding: 2px 3px;
  border-radius: 4px;
`

export const BuilderIntegrationsTemplate = {
  name: 'BuilderIntegrationsTemplate',
  components: {
    BuilderIntegrationsAuthTemplate,
  },
  data() {
    return {}
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      integrations: getters.GET_BUILDER_INTEGRATIONS_DATA,
      currentScreen: getters.GET_INTEGRATIONS_CURRENT_SCREEN,
    }),
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
      integrationsConfig: ({ builderIntegrationsConfig }) =>
        builderIntegrationsConfig,
    }),

    filteredIntegrations() {
      const updatedIntegrations = this.integrations.filter((item) => {
        const integrationKey = item.key

        return (
          this.integrationsConfig.hasOwnProperty(integrationKey) &&
          this.integrationsConfig[integrationKey].integrationEnabled
        )
      })
      return updatedIntegrations
    },
  },
  async created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors

    this.setBuilderIntegrationsConfig(this.config.BUILDER_INTEGRATIONS_CONFIG)
    // builder form integrations config
  },

  methods: {
    ...mapActions('globalTheme', {
      setBuilderIntegrationsConfig: 'setBuilderIntegrationsConfig',
    }),
    ...mapActions({
      selectIntegration: actions.SELECT_INTEGRATION,
    }),

    onClickIntegrateItem(item) {
      this.selectIntegration(item)
    },
  },
  render: function (h) {
    const IntegrationsContainer = getIntegrationsContainer()
    const IntegrationsItem = getIntegrationsItem()
    const IntegrationsAddItem = getIntegrationsAddItem()
    const IntegrateCheck = getIntegrateCheck()
    const IntegrationInnerContainer = getIntegrationInnerContainer()
    const IntegrationAddInnerContainer = getIntegrationAddInnerContainer()
    const IntegrationImage = getIntegrationImage()
    const IntegrationAddImage = getIntegrationAddImage()
    const IntegrationName = getIntegrationName()
    const IntegrationDescription = getIntegrationDescription()
    const InputContainer = getInputContainer()
    const ConnectInfoIconWrap = getConnectInfoIconWrap()
    const ConnectInfoIcon = getConnectInfoIcon()
    const InfoIcon = getInfoIcon()
    const IntegrationsHeading = getIntegrationsHeading()
    const IntegrateCheckIcon = getIntegrateCheckIcon()
    const IntegrationAddIcon = getIntegrationAddIcon()
    const IntegrationNewLabel = getIntegrationNewLabel()

    return (
      <div style="width: 100%;">
        {this.currentScreen === constants.INTEGRATIONS && (
          <div>
            <IntegrationsHeading>
              {this.$t('builder.integrations.header.text')}
            </IntegrationsHeading>
            <InputContainer>
              <CvtInput
                label=""
                size="small"
                mode={this.mode}
                color="black"
                placeholder="Search"
                value={''}
                onClear={() => {}}
                onInput={(e) => {}}
                suffixIcon="search"
              ></CvtInput>
              <ConnectInfoIconWrap>
                <ConnectInfoIcon>
                  <InfoIcon class="fa fa-info" />
                </ConnectInfoIcon>
                Connect your form to other apps
              </ConnectInfoIconWrap>
            </InputContainer>

            <IntegrationsContainer>
              {this.filteredIntegrations.map((integration) => (
                <IntegrationsItem
                  onClick={() => this.onClickIntegrateItem(integration)}
                >
                  <IntegrateCheck>
                    <span>
                      {integration.new && (
                        <IntegrationNewLabel>New</IntegrationNewLabel>
                      )}
                    </span>
                    <span>
                      {integration.complete && (
                        <IntegrateCheckIcon class="fa fa-check-circle" />
                      )}
                    </span>
                  </IntegrateCheck>
                  <IntegrationInnerContainer>
                    <IntegrationImage>
                      <img
                        style="height: 100%;"
                        src={integration.image}
                        alt={integration.title}
                      />
                    </IntegrationImage>
                    <IntegrationName> {integration.title} </IntegrationName>
                    <IntegrationDescription>
                      {integration.description}
                    </IntegrationDescription>
                  </IntegrationInnerContainer>
                </IntegrationsItem>
              ))}
              <IntegrationsAddItem>
                <IntegrationAddInnerContainer>
                  <IntegrationAddImage>
                    <IntegrationAddIcon class="fa fa-plus" />
                  </IntegrationAddImage>
                  <IntegrationName> Request an integration </IntegrationName>
                  <IntegrationDescription>
                    Please tell us about the integration you’re requesting
                  </IntegrationDescription>
                </IntegrationAddInnerContainer>
              </IntegrationsAddItem>
            </IntegrationsContainer>
          </div>
        )}

        {this.currentScreen === constants.AUTHENTICATE && (
          <BuilderIntegrationsAuthTemplate />
        )}
      </div>
    )
  },
}
